__turbopack_context__.v({
  "CTADescription": "CompactAdCards-module-scss-module__VNYfxa__CTADescription",
  "callToActionContainer": "CompactAdCards-module-scss-module__VNYfxa__callToActionContainer",
  "disclosureLink": "CompactAdCards-module-scss-module__VNYfxa__disclosureLink",
  "imageWrapper": "CompactAdCards-module-scss-module__VNYfxa__imageWrapper",
  "title": "CompactAdCards-module-scss-module__VNYfxa__title",
});
